// extracted by mini-css-extract-plugin
module.exports = {"form":"style_form__2nAt5","label":"style_label__1r7jK"};